import React, { useMemo } from "react";
import {
  formatDateIntoDMYToDisplay,
  gethoursAndMins,
} from "Utils/utils";
import CheckBox from "../../../../../components/common/checkBox/checkbox";

import { DELIVERED_SERVICE_STATUS_OPTIONS } from "Constants/constant";
import { getCaseNoteSupportItemDisplayName } from "Utils/caseNoteSupportItem";

const COSInvoicePreviewTabel = (props) => {
  const {
    item,
    isUserGracePeriodOver,
    handleCheckboxChange,
    checkboxes,
    showRowCheckbox = false,
  } = props;

  const showDataInTable = (item) => {
    try {
      const parsedData = JSON.parse(item.manged_by);
      const data = [];
      const filtedData = parsedData.filter((items) => {
        return items.label !== "NDIA Managed";
      });
      filtedData.forEach((element) => {
        data.push(element.label);
      });
      return data;
    } catch {
      return [];
    }
  };

  const mgmtLabel = useMemo(() => showDataInTable(item).join(", "), [item]);

  const dateDeliveredLabel = useMemo(() => {
    if (item.delivered_from && item.delivered_to_date) {
      return `${formatDateIntoDMYToDisplay(
        item.delivered_from
      )} - ${formatDateIntoDMYToDisplay(item.delivered_to_date)}`;
    }
    if (item.delivered_date) {
      return formatDateIntoDMYToDisplay(item.delivered_date);
    }
    return "-";
  }, [item]);

  const rateVal =
    item.alternative_rate && parseFloat(item.alternative_rate) > 0
      ? parseFloat(item.alternative_rate)
      : parseFloat(item.original_rate);

  const statusLabel =
    DELIVERED_SERVICE_STATUS_OPTIONS.find(
      (arr) => item.invoice_status === arr.value
    )?.label ?? "—";

  const supportItemDisplay = useMemo(
    () => getCaseNoteSupportItemDisplayName(item),
    [item]
  );

  return (
    <tr className='even:bg-white odd:bg-gray-50'>
      {showRowCheckbox && handleCheckboxChange && checkboxes && (
        <td className='w-[3%] px-1 py-3.5 align-top text-center text-base text-gray-700'>
          <CheckBox
            isDisabled={isUserGracePeriodOver}
            handleChange={(e) => handleCheckboxChange(e, item.id)}
            checked={checkboxes.indexOf(item.id) !== -1}
          />
        </td>
      )}
      <td className='w-[6%] min-w-0 px-3 py-3.5 align-top text-base text-gray-700 text-left'>
        <div className='truncate' title={String(item.delivered_service_number ?? "")}>
          {item.delivered_service_number}
        </div>
      </td>
      <td className='w-[6%] min-w-0 px-3 py-3.5 align-top text-base text-gray-700 capitalize text-left'>
        <div className='truncate' title={String(item.created_by ?? "")}>
          {item.created_by}
        </div>
      </td>
      <td className='w-[10%] min-w-0 px-3 py-3.5 align-top text-base text-gray-700 capitalize text-left'>
        <div className='truncate' title={String(item.participant ?? "")}>
          {item.participant}
        </div>
      </td>
      <td className='w-[8%] min-w-0 px-3 py-3.5 align-top text-base text-gray-700 text-left'>
        <div className='truncate' title={mgmtLabel}>
          {mgmtLabel}
        </div>
      </td>
      <td className='w-[11%] min-w-0 px-3 py-3.5 align-top text-base text-gray-700 text-left'>
        <div className='truncate' title={String(supportItemDisplay ?? "")}>
          {supportItemDisplay}
        </div>
      </td>
      <td className='w-[7%] min-w-0 px-3 py-3.5 align-top text-base text-gray-700 text-left'>
        <div className='truncate' title={String(item.support_item_number ?? "")}>
          {item.support_item_number}
        </div>
      </td>
      <td className='w-[6%] min-w-0 px-3 py-3.5 align-top text-base text-gray-700 text-left'>
        <div className='truncate' title={statusLabel}>
          {statusLabel}
        </div>
      </td>
      <td className='w-[12%] min-w-0 px-3 py-3.5 align-top text-base text-gray-700 text-left'>
        <div className='truncate' title={dateDeliveredLabel}>
          {dateDeliveredLabel}
        </div>
      </td>
      <td className='w-[4%] px-3 py-3.5 align-top text-base text-gray-700 whitespace-nowrap text-right tabular-nums'>
        {item.km || 0}
      </td>
      <td className='w-[5%] px-3 py-3.5 align-top text-base text-gray-700 whitespace-nowrap text-right'>
        {gethoursAndMins(item?.hours, item?.mints)}
      </td>
      <td className='w-[5%] px-3 py-3.5 align-top text-base text-gray-700 whitespace-nowrap text-right tabular-nums'>
        {`$${rateVal}`}
      </td>
      <td className='w-[8%] px-3 py-3.5 align-top text-base text-gray-700 whitespace-nowrap text-right tabular-nums'>
        {`$${item.total_amount ?? 0}`}
      </td>
      {/* <td className='w-[3%] px-1 py-3 align-top' aria-hidden='true' /> */}
    </tr>
  );
};

export default COSInvoicePreviewTabel;
